var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-img',{attrs:{"max-height":"17","max-width":"17","src":"/img/icons/product.svg"}})
}
var staticRenderFns = []

export { render, staticRenderFns }